import React from 'react'
import { FieldHookConfig, useField } from 'formik'
import { AutocompleteProps, InputLabelProps } from '@mui/material'

import AutocompleteCustom from '../autocomplete-custom/index.component'

interface Props
  extends Omit<
    AutocompleteProps<any, true, true, true>,
    'renderInput' | 'onChange' | 'value'
  > {
  label?: string
  placeholder?: string
  showChips?: boolean
  margin?: 'dense' | 'normal' | 'none'
  disableHelperError?: boolean
  handleChange?: (event: React.ChangeEvent<{}>, value: any) => void
  manuallySetValue?: boolean
  chipTags?: boolean
  inputLabelProps?: Partial<InputLabelProps>
  inputOnChange?: (value: string) => void
}

const InputFormikAutocomplete = ({
  multiple,
  disableHelperError,
  handleChange,
  manuallySetValue,
  inputOnChange,
  ...props
}: Props & FieldHookConfig<string>) => {
  const [field, meta, helpers] = useField(props)

  const { touched, error } = meta

  const showError = !disableHelperError && touched && Boolean(error)

  return (
    <AutocompleteCustom
      {...props}
      multiple={multiple}
      name={field.name}
      error={showError}
      helperText={showError ? error : undefined}
      value={
        field.value === '' || field.value === undefined ? null : field.value
      }
      onChange={(event: React.ChangeEvent<{}>, value: any, _reason: string) => {
        handleChange && handleChange(event, value)
        !manuallySetValue && helpers.setValue(value || (multiple ? [] : ''))
      }}
      inputOnChange={inputOnChange}
    />
  )
}

export default InputFormikAutocomplete
